var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ spinner: !_vm.small, 'spinner-small': !!_vm.small, 'spinner-dark': !!_vm.dark }},[(!_vm.small)?_c('span'):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }